import { render, staticRenderFns } from "./ClientChatView.vue?vue&type=template&id=bc416ca8&scoped=true&"
import script from "./ClientChatView.vue?vue&type=script&lang=js&"
export * from "./ClientChatView.vue?vue&type=script&lang=js&"
import style0 from "./ClientChatView.vue?vue&type=style&index=0&id=bc416ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc416ca8",
  null
  
)

export default component.exports